export default __webpack_public_path__ + "static/arrows-1928d0706ac01261ecdffcabb5e690a1.png";